import React from 'react';
import { format } from 'date-fns';
import { useState, useContext, useEffect } from 'react';
import FileSaver from 'file-saver';
import {useQuantitiesReportMutation} from "../../generated/graphql";
import {ToolbarContext} from "../../contexts/toolbar-context";
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button} from "@mui/material";
import {IsoDatePicker} from "../../components/IsoDatePicker";
import { useToast } from "../../contexts/toast";
import {progressToast} from "../../utils/progress-toast";

const QuantitiesReport = () => {
    const [dateFromValue, setDateFromValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [dateToValue, setDateToValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [isWait, setWait] = useState(false);
    const [mutation] = useQuantitiesReportMutation({ fetchPolicy: 'no-cache' });
    const toolbarContext = useContext(ToolbarContext);
    const {toast} = useToast();
    useEffect(() => {
        toolbarContext.setPrimary(
          {
            primary: [],
            title: 'Quantities Report'
          });
      }, []);
    function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }
    async function submitForm() {
        if (isWait) return;
        if(!dateFromValue || !dateToValue) return;
        const t = progressToast(toast)('QUANTITIES_REPORT');
        t.start("Generating report",{variant:'info'});
        setWait(true);
        try {
            const data = await mutation({variables: {dateFrom: dateFromValue, dateTo: dateToValue}});
            setWait(false);
            t.ok('Rendering file');
            const res = await fetch(data?.data?.quantitiesReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent,'quantities-report-'+dateFromValue+'__'+dateToValue+'.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            console.log('error',e);
            t.fail('Download failed');
            setWait(false);
        }
    }
    return <div><div>
        <Accordion defaultExpanded={true}>
            <AccordionSummary>Quantities Report</AccordionSummary>
            <AccordionDetails>
                <form method="POST" target="_blank">
                    <div className="grid12">
                        <IsoDatePicker className="grid12-3" name="dateFrom" value={dateFromValue} onChange={setDateFrom} label="Date Up From" />
                        <IsoDatePicker className="grid12-3"  name="dateTo" value={dateToValue} onChange={setDateTo} label="Date Up to" />
                    </div>
                </form>
            </AccordionDetails>
            <AccordionActions>
                  <Button variant="contained" onClick={submitForm}>Generate Report</Button>
            </AccordionActions>
        </Accordion></div></div>
}

export default QuantitiesReport;